import { memo } from 'react';
import { Button, Modal } from 'antd';
import IntlMessages from '../Message/IntlMessages';
import DisclaimerMessage from 'components/Message/DisclaimerMessage';
import { DisclaimerType } from 'const';

const AcceptPDPAComp = ({
  close, state, actions, ...modalProps
}) => {

  function onAccept() {
    close();
    actions?.onAccept && actions.onAccept(DisclaimerType.PDPA_COMP);
  }

  function _onCancel() {
    close();
    actions?.onCancel && actions.onCancel();
  }

  return (
    <Modal {...modalProps}>
      {modalProps.visible && (
        <div className="mnc-modal-disclaimer">
          <div className="modal-mnc-head">
            <h5 className="m-0">
              <IntlMessages id="modal.disclamer.header.pdpa-complex" />
            </h5>
            <Button className="btn button-ktb-close" onClick={_onCancel}>
              <i className="feather-icon icon-x"></i>{" "}
            </Button>
          </div>
          <div className="modal-mnc-body">
            <DisclaimerMessage code={DisclaimerType.PDPA_COMP} dangerous />
          </div>
          <div className="modal-mnc-footer">
            <div className="row justify-content-center">
              <div className="col-12 col-md-10">
                <div className="d-grid">
                  <Button data-accept-btn type="primary" className="btn button-ktb-main" onClick={onAccept}>
                    <IntlMessages id="modal.disclamer.button.pdpa-complex.accept" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Modal>
  )
}

export default memo(AcceptPDPAComp);